export default {
    // 自建表格删除
    selfBuildTableDrop(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/selfBuildTableDrop', params, response);
    },
    //通过sid删除设置条件按钮数据
    delSteSeriesButtonDataBySid(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/delSteSeriesButtonDataBySid', params, response);
    },
    //通过标识字段查询启用的最新版本按钮数据
    getSteSeriesButtonDataBySIgn(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getSteSeriesButtonDataBySIgn', params, response);
    },
    //通过标识字段查询设置条件按钮数据
    getTempSteSeriesButtonDataBySIgn(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getTempSteSeriesButtonDataBySIgn', params, response);
    },
    //保存设置条件按钮数据
    savSteSeriesButtonData(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/savSteSeriesButtonData', params, response);
    },
    //自建表格查询数据
    selfBuildTableSelect(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/selfBuildTableSelect', params, response);
    },
    //保存预览数据
    savePrviewData(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/savePrviewData', params, response);
    },
    //在流程中获取下一环节的处理人
    getNextTaskUsersOrGroups(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getNextTaskUsersOrGroups', params, response);
    },
    //复制模板功能
    copyTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/copyTemplate', params, response);
    },
    //查询设计流程字段
    queryDesignDataSource(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/queryDesignDataSource', params, response);
    },
    //新查询设计流程字段
    queryNewDesignDataSource(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/queryNewDesignDataSource', params, response);
    },
    //设计流程字段
    designDataSource(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/designDataSource', params, response);
    },
    // 模板导出
    exportModel(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/exportModelFile', params, response);
    },
    // 模板信息查询接口
    queryTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/queryTemplate', params, response);
    },
    // 模板删除接口
    deleteTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/deleteTemplate', params, response);
    },
    // 模板停用接口
    stopEnabled(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/suspendTemplate', params, response);
    },
    // 模板上传接口
    uploadTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/uploadTemplate', params, response);
    },
    // 模板启用接口
    immediatelyEnable(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/activateTemplate', params, response);
    },
    // 新建流程图
    newModel(params, response) {
        window.vue.$apiAxios.post('/models/newModel', params, response);
    },
    // 获取流程用户任务节点信息
    getNodeInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getTaskList', params, response);
    },
    // 用户接口
    listUserInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getAllUsers', params, response);
    },
    // 查询角色
    listRoleInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getRoleAuthList', params, response);
    },
    // 保存角色节点关联关系
    saveNodeUser(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/saveNodeUser', params, response);
    },
    batchSaveNodeUser(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/batchSaveNodeUser', params, response);
    },
    // 查询操作按钮信息
    getMenuList(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getMenuList', params, response);
    },
    // 流程启用接口
    submitLeaveBill(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/submitLeaveBill', params, response);
    },
    // 保存操作按钮信息
    saveMenuList(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/saveMenuList', params, response);
    },
    // 查询分配用户
    queryNodeUser(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getNodeUser', params, response);
    },
    // 获取任务环节所有出口路径
    getTaskOutgoings(params, response) {
        window.vue.$apiAxios.get('/templateManage/getTaskOutgoings', params, response);
    },
    //获取最大扩展排序值
    getMaxExtendOrder(params, response) {
        return window.vue.$apiAxios.get('/extendManage/getMaxExtendOrder', params, response);
    },
    //检测扩展组标识或扩展组名称是否存在
    checkGroupInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/checkGroupInfo', params, response);
    },
    //校验元素标识是否重复
    checkElementFlg(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/checkElementFlg', params, response);
    },
    //校验元素id是否重复
    checkElementSId(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/checkElementSId', params, response);
    },
    // 新增扩展元素信息接口
    insertExtendElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/insertExtendElement', params, response);
    },
    // 向扩展组中添加扩展元素信息
    insertGroupElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/insertGroupElement', params, response);
    },
    // 添加扩展组信息
    insertExtendGroup(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/insertExtendGroup', params, response);
    },
    // 查询扩展组中扩展元素信息接口
    listGroupElementInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/listGroupElementInfo', params, response);
    },
    // 检测扩展组中元素关键字是否重复
    checkElementKey(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/checkElementKey', params, response);
    },
    // 查询预览效果扩展元素值
    queryExtendValue(params, response) {
        return window.vue.$apiAxios.get('/extendManage/queryExtendValue', params, response);
    },
    // 查询扩展元素信息接口
    getDictTypeList(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dictController/getDictTypeList', params, response);
    },
    // 查询扩展元素信息接口
    getDictValuesByType(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dictController/getDictValuesByType', params, response);
    },
    // 删除扩展组中的扩展元素信息
    deleteGroupElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/deleteGroupElement', params, response);
    },
    // 删除扩展元素信息接口
    deleteExtendElementBatch(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/deleteExtendElementBatch', params, response);
    },
    // 更新扩展元素信息接口
    updateExtendElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/updateExtendElement', params, response);
    },
    // 添加流程扩展表关联关系
    insertExtProLink(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/insertExtProLink', params, response);
    },
    // 更新元素显示顺序
    updateSortInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/updateSortInfo', params, response);
    },
    // 查询字段列表
    listProcessElementInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/listProcessElementInfo', params, response);
    },
    // 查询流程参数
    getFlowParams(params, response) {
        return window.vue.$apiAxios.postRequestBody('/templateManage/getFlowParams', params, response);
    },
    // 保存流程参数
    saveActFlowParams(params, response) {
        return window.vue.$apiAxios.postRequestBody('/templateManage/saveActFlowParams', params, response);
    },
    // 重置流程参数
    deleteActFlowParamsByTask(params, response) {
        return window.vue.$apiAxios.postRequestBody('/templateManage/deleteActFlowParamsByTask', params, response);
    },
    // 查询历史任务信息
    findHisTask(params, response) {
        window.vue.$apiAxios.postRequestBody('/WorkFlowProcessQuery/findHisTask', params, response);
    },
    // 删除流程
    deleteProIns(params, response) {
        window.vue.$apiAxios.get('/WorkFlowProcessQuery/deleteProIns', params, response);
    },
    // 表单脚本导出
    exportFormModel(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/exportFormModel', params, response);
    },
    // 更新扩展组中的扩展元素信息
    updateGroupElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/updateGroupElement', params, response);
    },
    // 上传组件
    upload(params, response) {
        return window.vue.$apiAxios.postRequestBody('/fileStorage/upload', params, response);
    },
    // 下载
    batchExport(params, response) {
        return window.vue.$apiAxios.postRequestBody('/fileStorage/batchExport', params, response);
    },
    // 删除
    deleteFile(params, response) {
        return window.vue.$apiAxios.postRequestBody('/fileStorage/deleteFile', params, response);
    },
    queryConfigInfos(params, response) {
        return window.vue.$apiAxios.postRequestBody('/serviceSetup/queryConfigInfos', params, response);
    },
    getRoleAuthList(params, response) {
        return window.vue.$apiAxios.postRequestBody('/auth/role/getRoleAuthList', params, response);
    },
    //查询角色类型
    queryAllRoleType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/roleType/queryAllRoleType', params, response);
    },
    // 表单卸载脚本导出
    exportFormDel(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/exportFormDel', params, response);
    },
    //根据用户定义id获取已启用的最新部署实例定义id
    getActiveTemplateIdByKey(params, response) {
        window.vue.$apiAxios.get('/activiti/getActiveTemplateIdByKey', params, response);
    },
    publicNewVersion(params, response) {
        return window.vue.$apiAxios.postRequestBody('/service/publicNewVersion', params, response);
    },
    activateOldVersion(params, response) {
        return window.vue.$apiAxios.postRequestBody('/service/activateOldVersion', params, response);
    },
    deleteVersions(params, response) {
        return window.vue.$apiAxios.postRequestBody('/service/deleteVersions', params, response);
    },
    queryAllTemplates(params, response) {
        return window.vue.$apiAxios.postRequestBody('/templateManage/queryAllTemplates', params, response);
    },
    // 临时模板信息查询接口
    queryTempTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/queryTempTemplate', params, response);
    },
    // 保存表单元素类型属性
    saveExtendGroupElementType(params, response) {
        return window.vue.$apiAxios.postRequestBody('/customAudit/saveExtendGroupElementType', params, response);
    },
    // 批量删除表单元素类型属性
    deleteBatchExtendGroupElementType(params, response) {
        return window.vue.$apiAxios.postRequestBody('/customAudit/deleteBatchExtendGroupElementType', params, response);
    },
    //根据任务节点查询表单中扩展类型信息
    queryExtendTypeByTask(params, response) {
        return window.vue.$apiAxios.postRequestBody('/customAudit/queryExtendTypeByTask', params, response);
    },
    //保存自定义审核信息
    saveCustomization(params, response) {
        return window.vue.$apiAxios.postRequestBody('/customAudit/saveCustomization', params, response);
    },
    //查询自定义审核信息
    queryCustomAuditInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/customAudit/queryCustomAuditInfo', params, response);
    },
    // 查询扩展组
    queryLabelGroup(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabelGroup/queryLabelGroup', params, response);
    },
    // 查询档案信息
    queryAuditTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditGroupManage/queryAuditTree', params, response);
    },
    //保存指定分配信息
    saveAssignment(params, response) {
        return window.vue.$apiAxios.postRequestBody('/customAudit/saveAssignment', params, response);
    },
    //查询扩展元素信息
    queryExtendGroupElement(params, response) {
        window.vue.$apiAxios.postRequestBody('/customAudit/queryExtendGroupElement', params, response);
    }
};
